import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroAokSelectionPage } from './intro-aok-selection';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    IntroAokSelectionPage,
  ],
  imports: [
    IonicPageModule.forChild(IntroAokSelectionPage),
    PipesModule,
  ],
})
export class IntroAokSelectionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-aok-selection/intro-aok-selection.module.ts